/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdvanceChangeProposalRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {AdvanceChangeProposalResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const advanceChangeProposal = (request: AdvanceChangeProposalRequest, options?: CashRequestOptions) => post<AdvanceChangeProposalRequest, AdvanceChangeProposalResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/AdvanceChangeProposal", request, {...options, rejectOnError: true })